import { Admin } from "./components/Admin";
import { Gallery } from "./components/Gallery";

export function App() {
  const isAdmin = window.location.pathname === "/admin" || window.location.pathname.startsWith("/admin/");
  return (
    <>
      {!isAdmin && (
        <header className="site-header page-shell">
          <a className="brand" href="/">Nana Republic</a>
          <a className="studio-link" href="/admin">Studio</a>
        </header>
      )}
      {isAdmin ? <Admin /> : <Gallery />}
      {!isAdmin && (
        <footer className="site-footer page-shell"><span>Nana Republic</span><span>A visual prompt archive.</span></footer>
      )}
    </>
  );
}
